export enum Color {
    BLUE = '#0078f2'
}

export default Color;
